module.exports = __webpack_public_path__ + "media/customizations/regencyatmontaine/logo-772c4f56374a59118e38c2018eafe3f7.png";